import { browserName, osName, osVersion } from 'react-device-detect';

import { BaseLogger } from '../BaseLogger';
import type { LoggerServices, LogLevel } from '../constants';
import { SERVICE_NAME } from '../constants';
import type { Log, TLoggerMessages } from '../types';

class ClientLogger extends BaseLogger {
	private static instance: ClientLogger;
	private userId: string | undefined;
	private isTestUser = false;

	updateUserId = (userId: string | undefined, isTestUser: boolean) => {
		this.userId = userId;
		this.isTestUser = isTestUser;
	};

	static getInstance(): ClientLogger {
		if (!ClientLogger.instance) {
			ClientLogger.instance = new ClientLogger();
		}
		return ClientLogger.instance;
	}

	log = (
		level: LogLevel,
		service: LoggerServices,
		message?: TLoggerMessages,
		payload?: Record<string, unknown>
	) => {
		if (!BaseLogger.checkLogLevel(level)) {
			return;
		}

		this.logToDatadog(level, service, message, payload);
	};

	private logToDatadog = (
		level: LogLevel,
		service: LoggerServices,
		message?: TLoggerMessages,
		payload?: Record<string, unknown>
	): void => {
		const navInfo = navigator as NavigatorNetworkInformation;
		const connection: { effectiveType?: string } | undefined =
			navInfo.connection || navInfo.mozConnection || navInfo.webkitConnection;

		const log = {
			service,
			message,
			payload,
			product: SERVICE_NAME,
			userId: this.userId,
			connectionEffectiveType: connection?.effectiveType,
			browser: browserName,
			os: osName,
			osVersion,
		} as Log;

		if (typeof window !== 'undefined') {
			void import('./datadog').then((mod) => mod.Datadog.log(level, log));
		}
	};
}

export default ClientLogger.getInstance();
